<template>
  <article class="text-darkGray-1">
    <em> Gäller fr.o.m den 31 januari 2022 </em>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Personuppgiftsansvarig</h2>
      <p class="">
        Personuppgiftsansvarig för behandlingen såvitt gäller samordningen för
        Dina olika ansökningar i Ansökningsportal.se är {{ company.name }},
        {{ company.orgNumber }} {{ company.address }}, {{ company.zipCode }} {{ company.city }}, {{ company.country }}, nedan kallat
        ”Bolaget”.
      </p>
    </div>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Ändamål</h2>
      <p class="">
        Personuppgifterna används för att Du ska kunna samordna Dina
        ansökningar. 
      </p>
    </div>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Den rättsliga grunden för behandlingen</h2>
      <p class="">Behandlingens rättsliga grund är <em>samtycke</em>.</p>
    </div>
    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Mottagare</h2>
      <p class="">
        En tekniskt ansvarig vid Bolaget kan ta del av personuppgifterna.
        Personuppgifter lämnas endast ut till andra bolag om det behövs på grund
        av avtal, gällande rätt, för att skydda Bolagets eller tredje parts
        rättigheter.
      </p>
    </div>

    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Lagringstid</h2>
      <p class="">
        Personuppgifterna lagras under maximalt 36 månaders tid från att Du som
        registrerad har tillfört Bolaget personuppgifterna. Personuppgifterna sparas
        aldrig längre än vad som är nödvändigt för respektive ändamål.
      </p>
    </div>

    <div class="flex flex-col gap-2 my-4">
      <h2 class="text-lg font-bold">Dina rättigheter</h2>
      <p class="">
        Som registrerad har Du rätt att av Bolaget utan kostnad begära tillgång
        till, och rättelse eller radering av, personuppgifter eller begränsning
        av behandling som rör Dig eller att invända mot behandling samt
        dataportabilitet. Vissa uppgifter kan inte raderas om de måste sparas
        enligt gällande rätt.
      </p>
      <p>
        Du har rätt att när som helst återkalla Ditt samtycke till behandlingen,
        utan att detta påverkar lagligheten av behandlingen på grundval av
        samtycket, innan detta återkallades. Om det finns ett annat avtal som Du
        blir del av indirekt när Du lämnar samtycket kan inte samtycket
        återkallas direkt utan att det först tas hänsyn till avtalet.
      </p>

      <p>Begäran enligt ovan ska skriftligen skickas till:</p>
      <br/><br/>
        <strong>samtycke@ansokningsportal.se</strong>, alternativt till:<br />
        <div class="font-bold">
          <p>{{ company.name }}</p>
          <p>{{ company.address }}</p>
          <p>{{ company.zipCode }} {{ company.city }}</p>
        </div>
      <p>
        För att säkerställa att Bolaget lämnar ut uppgifterna till rätt person ska
        Din begäran innehålla uppgift om namn och personnummer, samt skickas
        från en e-postadress som är känd för Bolaget. Vid oklarheter kring Din
        identitet kan Bolaget begära att Du skickar Din begäran skriftligen och
        egenhändigt undertecknad.
      </p>

      <p>Du har rätt att ge in klagomål till <a href="https://www.imy.se/privatperson/utfora-arenden/lamna-ett-klagomal/" target="_blank" class="text-blue-1 underline" >Integritetsskyddsmyndigheten.</a></p>


      <p>
        Ditt tillhandahållande av personuppgifter förutsätts för att du ska
        kunna använda Bolagets tjänst. En följd av att inte lämna personuppgifter,
        eller att återkalla ett lämnat samtycke, är att Bolaget inte kan erbjuda
        tjänsten, de möjligheter som tjänsten innebär eller tillhandahålla
        ytterligare information.
      </p>
    </div>
  </article>
</template>
<script setup lang="ts">
  import { computed } from "vue";
  import { useStore } from "vuex";

  const store = useStore();
  const company = computed(() => {
    if (store.getters.publicContainer?.id === 377 || store.getters.publicContainer?.id === 382 || store.getters.publicContainer?.id === 388) {
      return {
        name: "Multi X Sweden AB",
        orgNumber: "556746-0414",
        address: "Georg Karlssons gata 5",
        zipCode: "781 70",
        city: "Borlänge",
        country: "Sverige",
      }
    } else {
      return {
        name: "Applicationportal Sweden AB",
        orgNumber: "559422-2860",
        address: "Georg Karlssons gata 5",
        zipCode: "781 70",
        city: "Borlänge",
        country: "Sverige",
      }
    }
  });
</script>
